
import WDElement from '../wd-element';
import WDCard from './wd-card';

/**
  not sure we even need a class, but it keeps the logic organized and allows
  for expandability later
  */
export default class WDCards extends WDElement {

  #config = {
    mode: 'flex',
    grid_class: 'col-12 col-sm-6'
  };
  
  //mode can be "grid", "deck" or "column", or "none" if we just want a vertically stacked
  //card set with a single row
  constructor(cfg)
  {
    super().classList.add('wd-cards');
    
    if (cfg) Object.assign(this.#config,cfg);
    this.classList.add(`wd-cards-${this.#config.mode}`);
    
    return this;
  };

  connectedCallback()
  {
    super.connectedCallback();
    
    if (this.#config?.cards)
    {
      this.#config.cards.forEach( card => this.add(card) );
    }
  };

  get config() { return this.#config; };
  
  add(optsOrCard)
  {
    const card = ( optsOrCard?.classList?.contains('wd-card') ) ? optsOrCard : new WDCard(optsOrCard);
    const wrapper = wdc('<div class="wd-card-wrapper"/>');

    wrapper.append(card);
    this.append(wrapper);
    
    return card;
  };

};

customElements.define('wd-cards',WDCards);
